'use client';

import { useEffect } from 'react';
import { trackToolView } from '@/app/lib/trackStats';

// Fires one `toolViewed` event per tool per UTC day per browser session.
// Gating prevents a user who reloads a tool page 10 times from inflating the view count.
export function useTrackToolView(tool: string) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const today = new Date().toISOString().split('T')[0];
    const key = `mcwt_view_${tool}_${today}`;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch {
      // sessionStorage disabled (private mode / quota) — fall through and track anyway.
    }
    trackToolView(tool);
  }, [tool]);
}
